module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/moments-of-pleasure-1200x630.7a64c0d4.jpg";